import { RESOURCE_NAME } from '@esentai/core/features/efsVisitRecords/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadEfsVisitRecords = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateEfsVisitRecords = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateEfsVisitRecords = authorizeIf(canUpdate(RESOURCE_NAME));
